'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.values = exports.OSOBA = exports.INTDOR = exports.TEL = exports.EMAIL = exports.DS = exports.ADRDOR = exports.ADRDORREG = exports.ADRTRVSDL = exports.ADR = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _params;

exports.getCaption = getCaption;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// @Conf
// #hasDoc=true

// ##############################################################

// #             GENEROVANÝ KÓD, NEMODIFIKOVAT!!!!              #

// #                  2024-04-03T14:18:46Z                      #

// ##############################################################

/**
 * Určuje typ kontaktu. @author Pavel Stánek [pavel.stanek@marbes.cz] @since 26.01.2017
 */

/**
 * Adresa.
 */
var ADR = exports.ADR = 'ADR';

/**
 * Adresa trvalého pobytu/sídla.
 */
var ADRTRVSDL = exports.ADRTRVSDL = 'ADRTRVSDL';

/**
 * Doručovací adresa z registrů.
 */
var ADRDORREG = exports.ADRDORREG = 'ADRDORREG';

/**
 * Kontaktní doručovací adresa.
 */
var ADRDOR = exports.ADRDOR = 'ADRDOR';

/**
 * Datová schránka.
 */
var DS = exports.DS = 'DS';

/**
 * E-mail.
 */
var EMAIL = exports.EMAIL = 'EMAIL';

/**
 * Telefon.
 */
var TEL = exports.TEL = 'TEL';

/**
 * Interní doričení.
 */
var INTDOR = exports.INTDOR = 'INTDOR';

/**
 * Kontaktní osoba.
 */
var OSOBA = exports.OSOBA = 'OSOBA';

/**
 * Seznam všech hodnot.
 */
var values = exports.values = [ADR, ADRTRVSDL, ADRDORREG, ADRDOR, DS, EMAIL, TEL, INTDOR, OSOBA];

/**
 * Mapa enumu na objekt s podrobnostmi o enumu.
 */
var params = (_params = {}, (0, _defineProperty3.default)(_params, ADR, { caption: 'Adresa.' }), (0, _defineProperty3.default)(_params, ADRTRVSDL, { caption: 'Adresa trvalého pobytu/sídla.' }), (0, _defineProperty3.default)(_params, ADRDORREG, { caption: 'Doručovací adresa z registrů.' }), (0, _defineProperty3.default)(_params, ADRDOR, { caption: 'Kontaktní doručovací adresa.' }), (0, _defineProperty3.default)(_params, DS, { caption: 'Datová schránka.' }), (0, _defineProperty3.default)(_params, EMAIL, { caption: 'E-mail.' }), (0, _defineProperty3.default)(_params, TEL, { caption: 'Telefon.' }), (0, _defineProperty3.default)(_params, INTDOR, { caption: 'Interní doričení.' }), (0, _defineProperty3.default)(_params, OSOBA, { caption: 'Kontaktní osoba.' }), _params);

/**
 * Načtení popisku enumu.
 * @return popisek enumu
 */
function getCaption(value) {
  return params[value].caption;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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